import { useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import styles from "./PublicRegistration.module.css";

interface BenefitsSectionProps {
  isCertificate?: boolean;
}

export default function BenefitsSection({
  isCertificate = false,
}: BenefitsSectionProps) {
  const benefits = [
    {
      title: "Flexibilitate și suport complet",
      description: isCertificate
        ? Vocabulary.certificateBenefitsText
        : Vocabulary.benefitsText,
    },
    {
      title: "Tot inclus în preț",
      description: isCertificate
        ? Vocabulary.certificateIncludedInPrice
        : Vocabulary.includedInPrice,
    },
    {
      title: "Prețuri și plăți flexibile",
      description: isCertificate
        ? Vocabulary.certificatePriceNotes
        : Vocabulary.priceNotes,
    },
  ];
  const [showMoreLastBenefit, setShowMoreLastBenefit] = useState(false);

  const getDisplayText = (text: string, isLastBenefit: boolean) => {
    if (!isLastBenefit) return text;

    if (!showMoreLastBenefit) {
      const words = text.split(" ");
      const firstWords = words.slice(0, 15).join(" ");
      return firstWords + (words.length > 15 ? "..." : "");
    }
    return text;
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardIcon}>
          <svg
            className={styles.iconSmall}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
            />
          </svg>
        </div>
        <h3 className={styles.cardTitle}>Beneficiile tale</h3>
      </div>
      <div className={styles.benefitsList}>
        {benefits.map((benefit, index) => {
          const isLastBenefit = index === benefits.length - 1;
          const displayText = getDisplayText(
            benefit.description,
            isLastBenefit
          );

          return (
            <div key={index} className={styles.benefitItem}>
              <div className={styles.benefitIcon}>
                <div className={styles.cardIcon}>
                  <svg
                    className={styles.iconSmall}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.benefitContent}>
                <h4 className={styles.benefitTitle}>{benefit.title}</h4>
                <p className={styles.benefitDescription}>
                  {displayText}
                  {isLastBenefit && (
                    <span
                      className={styles.seeMoreButton}
                      onClick={() =>
                        setShowMoreLastBenefit(!showMoreLastBenefit)
                      }
                    >
                      {" "}
                      {showMoreLastBenefit ? "Vezi mai puțin" : "Vezi mai mult"}
                    </span>
                  )}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
